import css from '@emotion/css'
import { Heading, HFlow, Tabs, VFlow } from 'bold-ui'
import useSession from 'components/auth/useSession'
import { Breadcrumb } from 'components/breadcrumb'
import { PageContainer } from 'components/layout/PageContainer'
import { BadgeNotificacao } from 'components/notificacao/BadgeNotificacao'
import { PecSwitch, PrivateRoute, TabLink } from 'components/route'
import { useFlags } from 'config/useFlagsContext'
import { TipoTopicoNotificacaoEnum } from 'graphql/types.generated'
import React, { Fragment } from 'react'
import { useRouteMatch } from 'react-router'
import { NIVEL_SUPERIOR } from 'types/NivelCbo'
import Permissions from 'types/Permissions'
import { DemandaReprimidaRootView } from 'view/lista-espera/DemandaReprimidaRootView'
import { useNotificacaoCount } from 'view/notificacao/hooks/useNotificacaoCount'

import { RegulacaoView } from './regulacao/RegulacaoView'

export const GarantiaAcessoRootView = () => {
  const { PILOTO_INTEGRACAO_REGULACAO_ENABLED } = useFlags()
  const match = useRouteMatch()
  const { checkAuthorization, hasCboAuth } = useSession()
  const totalNotificacoes = useNotificacaoCount([TipoTopicoNotificacaoEnum.REGULACAO_ASSISTENCIAL])

  const GA_DEMANDA_REPRIMIDA_PATH = PILOTO_INTEGRACAO_REGULACAO_ENABLED
    ? `${match.url}/garantia-acesso/demanda-reprimida`
    : `${match.url}/garantia-acesso/`
  const GA_REGULACAO_PATH = `${match.url}/garantia-acesso/regulacao`

  const isCboNivelSuperior = checkAuthorization(Permissions.visualizarProntuario) && hasCboAuth(NIVEL_SUPERIOR)

  return (
    <>
      <Breadcrumb title='Garantia do acesso' />
      <PageContainer fluid style={styles.pageContainer}>
        <VFlow>
          <Heading level={1} style={styles.heading}>
            Garantia do acesso
          </Heading>
          {PILOTO_INTEGRACAO_REGULACAO_ENABLED && isCboNivelSuperior && (
            <Tabs>
              <Fragment>
                <TabLink to={GA_DEMANDA_REPRIMIDA_PATH}>Nesta unidade de saúde</TabLink>

                <TabLink to={GA_REGULACAO_PATH}>
                  <HFlow hSpacing={0.5}>
                    Regulação assistencial
                    <BadgeNotificacao value={totalNotificacoes} type='large' />
                  </HFlow>
                </TabLink>
              </Fragment>
            </Tabs>
          )}
        </VFlow>
      </PageContainer>

      <PecSwitch>
        <PrivateRoute
          path={GA_DEMANDA_REPRIMIDA_PATH}
          component={DemandaReprimidaRootView}
          permission={Permissions.visualizarListaDeAtendimento}
        />
        {PILOTO_INTEGRACAO_REGULACAO_ENABLED && (
          <PrivateRoute
            path={GA_REGULACAO_PATH}
            component={RegulacaoView}
            permission={Permissions.visualizarListaDeAtendimento}
            cbos={NIVEL_SUPERIOR}
          />
        )}
      </PecSwitch>
    </>
  )
}

const styles = {
  heading: css`
    margin-top: 0.5rem;
    margin-bottom: 0;
  `,
  pageContainer: css`
    padding: 1rem 2rem 0rem 2rem;
  `,
}
